// @flow
// Having to type this ugly, repetetive way because this issue:
// https://github.com/facebook/flow/issues/2377
export const LOG_IN: 'LOG_IN' = 'LOG_IN';
export const LOG_OUT: 'LOG_OUT' = 'LOG_OUT';

export const API_URL_SET: 'API_URL_SET' = 'API_URL_SET';

export const RESOURCE_REQUEST: 'RESOURCE_REQUEST' = 'RESOURCE_REQUEST';
export const RESOURCE_FAIL_TO_RECEIVE: 'RESOURCE_FAIL_TO_RECEIVE' =
  'RESOURCE_FAIL_TO_RECEIVE';
export const RESOURCE_RECEIVE: 'RESOURCE_RECEIVE' = 'RESOURCE_RECEIVE';
export const ADD_SCANNED_PRODUCTS: 'ADD_SCANNED_PRODUCTS' =
  'ADD_SCANNED_PRODUCTS';
export const CLEAR_SCANS: 'CLEAR_SCANS' = 'CLEAR_SCANS';
export const REMOVE_SCAN: 'REMOVE_SCAN' = 'REMOVE_SCAN';
export const ADD_SCAN: 'ADD_SCAN' = 'ADD_SCAN';
export const UPDATE_SCAN_WITH_CODES: 'UPDATE_SCAN_WITH_CODES' =
  'UPDATE_SCAN_WITH_CODES';
export const RESOLVE_SCAN: 'RESOLVE_SCAN' = 'RESOLVE_SCAN';
export const ERROR_SCAN: 'ERROR_SCAN' = 'ERROR_SCAN';
export const CLOSE_BARCODE_SCANNING: 'CLOSE_BARCODE_SCANNING' =
  'CLOSE_BARCODE_SCANNING';
export const OPEN_BARCODE_SCANNING: 'OPEN_BARCODE_SCANNING' =
  'OPEN_BARCODE_SCANNING';
export const EXTERNAL_PRICES_CLEAR: 'EXTERNAL_PRICES_CLEAR' =
  'EXTERNAL_PRICES_CLEAR';
export const UPDATE_USER_IS_DISABLED: 'UPDATE_USER_IS_DISABLED' =
  'UPDATE_USER_IS_DISABLED';
